export const CONNECTOR_TYPE_CUSTOM = 'Custom';
export const CONNECTOR_DESTINATION_CUSTOM = 'Custom Connector';
